import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import PublicNavigator from "./navigators/PublicNavigator.jsx";
import DashboardNavigator from "./navigators/DashboardNavigator.jsx";
import ErrorAlert from "./components/ErrorAlert/ErrorAlert.component";
import SuccessAlert from "./components/SuccessAlert/SuccessAlert.component";
import ScrollToTop from "./components/scrollToTop/scrollToTop.component";
import withRoot from "./withRoot.jsx";
import { clearErrors } from "./redux/layout/layoutActions";
import Login from "./pages/login/login.page";

function App() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  document.body.dir = i18n.dir();

  useEffect(() => {
    dispatch(clearErrors());
  }, [dispatch]);

  return (
    <>
      <SuccessAlert />
      <ErrorAlert />
      <ScrollToTop />
      {currentUser && currentUser !== 'SESSION_EXPIRED' ? (
        <DashboardNavigator /> 
      ) : (
        <PublicNavigator isSessionExpired={currentUser === 'SESSION_EXPIRED'} />
      )}
    </>
  );
}

export default withRoot(App); 